// extracted by mini-css-extract-plugin
module.exports = {"modal":"NiceModal_modal__2QJ6z"};